{
    "saveAttributeTitle": "Save Attribute",
    "saveFilterTitle": "Save Filter",
    "saveRevisionTitle": "Please enter a comment for this code revision",
    "checkingCodeSave": "Are you sure you would like to save this code?",
    "codeSaved": "The code was successfully saved"
}